<rx-modal-content (closeModal)="activeModal.dismiss()">
  <h3 class="modal-title">
    {{ selectedRoom?.name }}
  </h3>
  <div class="modal-body">
    <p [innerHTML]="selectedRoom.description | cleanupHtml | safeHtml"></p>
  </div>
</rx-modal-content>
